import { post } from 'utils';

export default function requestLink(
  params = {},
  onSuccess = () => {},
  onError = () => {}
) {
  post({ apiKey: 'auth.requestLink', noTokenRequired: true }, { params })
    .then(({ data }) => onSuccess(data))
    .catch(onError);
}
